import React, { useContext } from "react";
import { ConfigurationContext, StepsContext } from "contexts";
import { Steps as AntSteps } from "antd";
import { Typography } from "antd";

const { Title } = Typography;
const AntStep = AntSteps.Step;

export const Progress = () => {
  let config = useContext(ConfigurationContext);
  let [steps] = useContext(StepsContext);

  if (!config) {
    // The configuration hasn't loaded yet.
    return null;
  }

  const progressSteps = [
    {
      title: <Title level={4}>Start</Title>,
      //  content: "Performing system checks",
      error: steps.state.start.error,
      success: steps.state.start.completed,
      show: config.steps.start,
      working: steps.current.index === 0,
    },
    {
      title: <Title level={4}>Gathering Data</Title>,
      //  content: "Searching for non-personal data",
      error: steps.state.browserDetection.error,
      success: steps.state.browserDetection.completed,
      show: config.steps.browserDetection,
      working: steps.current.index === 1,
    },
    {
      title: <Title level={4}>Detection Application</Title>,
      //    content: <>Downloading detection application</>,
      error: steps.state.appDetection.error,
      success: steps.state.appDetection.completed,
      show: config.steps.appDetection,
      working: steps.current.index === 2,
    },
    // {
    //   title: <Title level={4}>Network Speed Tests</Title>,
    //   //    content: <>Running network speed tests</>,
    //   error: steps.state.speedTestDetection.error,
    //   success: steps.state.speedTestDetection.completed,
    //   show: config.steps.speedTestDetection,
    //   working: steps.current.index === 3,
    // },
    {
      title: <Title level={4}>Internet Speed Tests</Title>,
      //    content: "Running network latency tests",
      error: steps.state.networkDetection.error,
      success: steps.state.networkDetection.completed,
      show: config.steps.networkDetection,
      working: steps.current.index === 3,
    },
    {
      title: <Title level={4}>Finish</Title>,
      //     content: "",
      error: steps.state.finish.error,
      success: steps.state.finish.completed,
      show: config.steps.finish,
      working: steps.current.index === 4,
    },
  ];

  // Adjust the step to match the visible progress steps.

  let step = steps.step;

  // Adjust to the first visible step.
  while (step < progressSteps.length && !progressSteps[step].show) {
    ++step;
  }

  if (step === progressSteps.length) {
    step--;
  }

  // Count the non-visible steps.
  let missing = 0;
  for (let n = step; n >= 0; --n) {
    if (!progressSteps[n].show) {
      ++missing;
    }
  }

  step -= missing;
  if (step < 0) {
    step = 0;
  }

  const status = (item) => {
    if (item.error) {
      return "error";
    }
    if (item.success) {
      return "finish";
    }
    if (item.working) {
      return "process";
    }

    return "wait";
  };

  return (
    <div className="mt-5 d-none d-md-block">
      <AntSteps
        style={{ background: "0xfff" }}
        direction="vertical"
        current={step}
      >
        {progressSteps.map((item) =>
          item.show ? (
            <AntStep
              key={item.title}
              title={item.title}
              status={status(item)}
              description={item.content}
            />
          ) : null
        )}
      </AntSteps>
    </div>
  );
};
